<template>
    <!-- Adjust Size -->
    <div class="row">
      <div class="col-md-12">
        <div class="grid">
          <div class="grid-title">
            <h4>Adjust Lady Sizes</h4>
          </div>
          <div class="grid-body">
            <div class="row">
              <div class="col-sm-2">
                <label>Collar</label>
                <input
                  v-model="convertedSize.collar"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="col-sm-2">
                <label>Chest</label>
                <input type="text" v-model="convertedSize.bust" class="form-control" />
              </div>
              <div class="col-sm-2">
                <label>Waist</label>
                <input
                  v-model="convertedSize.waist"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="col-sm-2">
                <label>Hip</label>
                <input
                  v-model="convertedSize.seam"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="col-sm-2">
                <label>Arm Length</label>
                <input
                  v-model="convertedSize.arm_length"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="col-sm-2">
                <label>Front Length</label>
                <input
                  v-model="convertedSize.front_length"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="col-sm-2">
                <label>Biceps</label>
                <input v-model="convertedSize.biceps" type="text" class="form-control" />
              </div>
              <div class="col-sm-2">
                <label>Scale Length</label>
                <input v-model="convertedSize.bust2dart" type="text" class="form-control" />
              </div>
              <div class="col-sm-2">
                <label>Wrist</label>
                <input v-model="convertedSize.cuff_length" type="text" class="form-control" />
              </div>
              <div class="col-sm-2">
                <label>Broad Shoulders</label>
                <input v-model="convertedSize.shoulder" type="text" class="form-control" />
              </div>
              <div class="col-sm-2">
                <label>Back Length</label>
                <input v-model="convertedSize.back_length" type="text" class="form-control" />
              </div>
              <div class="col-sm-2">
                <label>Belt</label>
                <input v-model="convertedSize.belt" type="text" class="form-control" />
              </div>

              <div class="col-md-12">
                <br />
                <button
                  class="btn btn-block btn-success"
                  @click="updateSizes()"
                  v-if="!isReadOnlyUser"
                >
                  UPDATE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import Swal from "sweetalert2";
  export default {
    props: {
      isReadOnlyUser: {
        type: Boolean,
        default: false,
      },
      size: {
        type: Object,
        default: {},
      },
    },
    computed: {
      convertedSize() {
        const converted = {};
        for (const field in this.size) {
          if (this.size.hasOwnProperty(field)) {
            converted[field] = this.size[field] / 10;
          }
        }
        return converted;
      }
    },
    methods: {
      async updateSizes() {
        try {
          const originalSize = {};
          for (const field in this.convertedSize) {
            if (this.convertedSize.hasOwnProperty(field)) {
              originalSize[field] = this.convertedSize[field] * 10;
            }
          }
          let res = await axios.put("shirt_orders/update/lady_size", { lady_size: originalSize });
          if (res) {
            Swal.fire("Success", "Successfully Updated", "success");
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      },
      round(t) {
        return round(t, 2);
      },
    },
  };
  </script>
  
  <style scoped>
  .form-control {
    margin-bottom: 10px;
    height: 42px !important;
    border-radius: 4px !important;
  }
  .select {
    width: 100% !important;
    height: 42px !important;
    border-radius: 4px !important;
  }
  h4 {
    font-weight: bold !important;
  }
  .grid-title {
    border-top: 1px solid #eee;
  }
  </style>
  